
























import IconBox from './IconBox.vue';

export default {
  name: 'ConnectorBox',
  components: {
    IconBox,
  },
  props: {
    leftSrc: {
      type: String,
      default: null,
    },
    rightSrc: {
      type: String,
      default: null,
    },
  },
};
